import { store } from "app/store";

let propertyPolygons = [];

export const renderGlidePolygon = (map, active_property, map_mode) => {
  propertyPolygons.map((propertyPolygon, i) => {
    //window.google.maps.event.clearListeners(propertyPolygon, 'click');
    propertyPolygon.setMap(null);
    return propertyPolygon;
  });
  if (map_mode == "glide" && active_property) {
    if (active_property.coordinates) {
      for (let i = 0; i < active_property.coordinates.length; i++) {
        let coordinates = [];
        for (let j = 0; j < active_property.coordinates[i].length; j++) {
          coordinates.push({
            lat: parseFloat(active_property.coordinates[i][j].latitude),
            lng: parseFloat(active_property.coordinates[i][j].longitude)
          });
        }

        //get owner street number

        let fillColor = "rgba(49,204,229, 0.2)";
        let strokeColor = "rgba(49,204,229, 0.7)";
        let drawnPolygon = new window.google.maps.Polygon({
          strokeColor: strokeColor,
          fillColor: fillColor,
          strokeWeight: 2,
          strokeOpacity: 0.7,
          fillOpacity: 0.2,
          property: active_property,
          path: coordinates,
          click: e => {}
        });

        drawnPolygon.setMap(map);

        /*
        window.google.maps.event.addListener(drawnPolygon, 'click', function (event) {
            //alert the index of the polygon
            togglePolygonClicked();
            onPropertyPress(drawnPolygon.property);
        });
        */
        propertyPolygons.push(drawnPolygon);
      }
    }
  }
};

export const renderHighlights = (map, properties, show_highlights = true) => {
  const colors = store.getState().settings.colors;

  propertyPolygons.map((propertyPolygon, i) => {
    //window.google.maps.event.clearListeners(propertyPolygon, 'click');
    propertyPolygon.setMap(null);
    return propertyPolygon;
  });

  if (properties && show_highlights) {
    for (let i = 0; i < properties.length; i++) {
      const property = properties[i];
      if (property.coordinates) {
        for (let i = 0; i < property.coordinates.length; i++) {
          let coordinates = [];
          for (let j = 0; j < property.coordinates[i].length; j++) {
            coordinates.push({
              lat: parseFloat(property.coordinates[i][j].latitude),
              lng: parseFloat(property.coordinates[i][j].longitude)
            });
          }

          //get owner street number

          let fillColor = colors.success_color;
          let strokeColor = colors.success_color;
          let drawnPolygon = new window.google.maps.Polygon({
            strokeColor: strokeColor,
            fillColor: fillColor,
            strokeWeight: 2,
            strokeOpacity: 1,
            fillOpacity: 0.2,
            property: property,
            path: coordinates,
            click: e => {}
          });

          drawnPolygon.setMap(map);

          /*
          window.google.maps.event.addListener(drawnPolygon, 'click', function (event) {
              //alert the index of the polygon
              togglePolygonClicked();
              onPropertyPress(drawnPolygon.property);
          });
          */
          propertyPolygons.push(drawnPolygon);
        }
      }
    }
  }
};
